import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaInstagram } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Contact Us
								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								>

								</span>
							</h6>
						</div>

						

						<div className="col-md-12">
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									
									window.open('mailto:info@caremedgaslimited.com', '_blank')
									
								}}
								className="font-bold text-dark"
							>
								<MdEmail size={32}/> info@caremedgaslimited.com
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open('tel:+255705998527', '_blank')
								}}
								className="font-bold text-dark"
							>
								<MdCall size={32}/> +255705998527
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/255705998527", "_blank");
							
								}}
								className="font-bold text-dark"
							>
								<MdWhatsapp size={32}/> Click to chat with us on WhatsApp
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://www.instagram.com/caremed_gas_ltd?igsh=ZzBiamU5M3FwaGRm&utm_source=qr", "_blank");
							
								}}
								className="font-bold text-dark"
							>
								<FaInstagram size={32}/> Follow us on Instagram
							</h6>

							
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
